import type { UseDateTimeTextFormatterArgs } from '../../hooks';
import { Tooltip } from '@workramp/ui';
import { useDateFormatter, useDateTimeTextFormatter } from '../../hooks';

export interface DateTextProps extends Omit<UseDateTimeTextFormatterArgs, 'dateStyle'> {
  date: number | string | Date;
  showTooltip?: boolean;
  dateStyle?: Intl.DateTimeFormatOptions['dateStyle'];
}

export function DateText({
  date,
  showTooltip = true,
  isLocalTime = false,
  timezone = 'UTC',
  dateStyle = 'short',
  ...props
}: DateTextProps) {
  const shortDateFormatter = useDateFormatter({ dateStyle, timeZone: isLocalTime ? undefined : timezone });
  const longDateFormatter = useDateTimeTextFormatter({
    isLocalTime,
    timezone,
    dateStyle: 'short',
    showWeekday: true,
    ...props,
  });

  const text = <span>{shortDateFormatter.format(new Date(date))}</span>;

  if (showTooltip) {
    return <Tooltip message={longDateFormatter.format(new Date(date))}>{text}</Tooltip>;
  }

  return text;
}
